export class Question {
    question: string;
    answers: Array<any>;
}
